import * as React from 'react';
export const MetaRenderer = ({ config, resolvers, ...globalProps }) => {
    if (!Array.isArray(config))
        return null;
    const elements = config.map((item, i) => {
        if (item === null)
            return null;
        if (typeof item === 'string')
            item = [item, {}];
        if (!Array.isArray(item))
            return null;
        if (item.length !== 2)
            return null;
        const [componentId, componentProps] = item;
        if (!componentId) {
            return null;
        }
        const Component = resolvers[componentId];
        if (!Component) {
            return null;
        }
        const mappedComponentProps = convertNestedMetasToComponents(componentProps, {
            config,
            resolvers,
            ...globalProps,
        });
        return React.createElement(Component, { key: i, ...globalProps, ...mappedComponentProps });
    });
    return React.createElement(React.Fragment, null, elements);
};
function convertNestedMetasToComponents(componentProps, props) {
    if (componentProps && typeof componentProps === 'object') {
        if ('$component' in componentProps && componentProps.$component) {
            return props.resolvers[componentProps.$component];
        }
        else if ('$meta' in componentProps && componentProps.$meta) {
            return React.createElement(MetaRenderer, { ...props, config: componentProps.$meta });
        }
        else {
            if (Array.isArray(componentProps)) {
                return componentProps.map((element) => convertNestedMetasToComponents(element, props));
            }
            else {
                return Object.fromEntries(Object.entries(componentProps).map(([key, value]) => [
                    key,
                    convertNestedMetasToComponents(value, props),
                ]));
            }
        }
    }
    else {
        return componentProps;
    }
}
//# sourceMappingURL=meta-renderer.js.map